import { parse, format, parseISO } from "date-fns";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BsBuilding } from "react-icons/bs";
import { PiChartLineDownBold } from "react-icons/pi";
import { FaSpinner } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FaChevronRight } from "react-icons/fa6";
import { useMarketToggle } from "../../context/MarketContext.js";
import { useOption } from "../../context/OptionContext";
import { MdOutlineNoteAdd } from "react-icons/md";

import { usePcr } from "../../context/PcrContext.js";
import "./SearchStock.jsx";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  ComposedChart,
} from "recharts";
import {
  FaRupeeSign,
  FaArrowUp,
  FaArrowDown,
  FaChartLine,
  FaChartBar,
  FaProjectDiagram,
} from "react-icons/fa";
import { MdBarChart, MdShowChart } from "react-icons/md";
import axios from "axios";
const stockCache = {};
const SearchStock = () => {
  const { searchtext } = useParams();
  const navigate = useNavigate();
  console.log("Search", searchtext);
  const { market, toggleMarket } = useMarketToggle();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const BASE_URL = "http://localhost:8000";
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [stock, setStock] = useState(null);
  const [historical, setHistorical] = useState([]);
  const [closingPrices, setClosingPrices] = useState([]);
  const [dateData, setDateData] = useState([]);
  const [stockDataId, setStockDataId] = useState([]);
  const [intraday, setIntraday] = useState(null);
  const [timeFrame, setTimeFrame] = useState("day");
  const [lastFetched, setLastFetched] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [targetPrice, setTargetPrice] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(""); //time
  const [error, setError] = useState(null);
  const { pcrStore, loadData, refresh } = usePcr();
  const { fetchBySymbol, pcr } = useOption();
  const [peerPEData, setPeerPEData] = useState([]);
  const [indicators, setIndicators] = useState({
    rsi: [],
    ema: [],
    sma: [],
    macd: [],
  });
  // useEffect(() => {
  //   const fetchDetails = async () => {
  //     try {
  //       setLoading(true);
  //       // const response = await axios.get("http://localhost:8000/api/stock",
  //       const response = await axios.get(`${BASE_URL}/api/stock`, {
  //         params: { stock_name: searchtext },
  //       });
  //       setDetail(response.data);
  //     } catch (err) {
  //       console.log("Error is:-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchDetails();
  // }, [searchtext]);
  // console.log("Details", detail);

  // const nseCode = detail?.nse_scrip_code;
  // console.log("Nsecode", nseCode);

  // useEffect(() => {
  //   const fetchLiveStock = async () => {
  //     try {
  //       setLoading(true);
  //       // const response = await axios.post("http://localhost:8000/api/nsedata",
  //       const response = await axios.post(`${BASE_URL}/api/nsedata`, {
  //         stock_symbols: [nseCode],
  //       });
  //       setStock(response.data[nseCode]);
  //     } catch (err) {
  //       console.log("Error is:-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const fetchStockData = async () => {
  //     try {
  //       setLoading(true);
  //       // const response = await axios.get("http://localhost:8000/api/stockdata",
  //       const response = await axios.get(`${BASE_URL}/api/stockdata`, {
  //         params: { symbol: nseCode }, // ✅ correct
  //       });
  //       console.log("StockId data", response.data);
  //       setStockDataId(response.data);
  //     } catch (err) {
  //       console.log("Error is :-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const fetchHistorical = async () => {
  //     if (!nseCode) {
  //       console.warn("No NSE Code provided");
  //       return;
  //     }

  //     try {
  //       setLoading(true);

  //       // const response = await axios.get( "http://localhost:8000/api/historical",
  //       const response = await axios.get(`${BASE_URL}/api/historical`, {
  //         params: {
  //           stock_name: nseCode,
  //           period: "6m",
  //           filter: "price",
  //         },
  //       });

  //       console.log("Full API Response:", response.data);

  //       // Safely extract data
  //       const histData = response.data?.historicalData?.data || [];
  //       const closing = response.data?.closingPrices || [];
  //       const indi = response.data?.indicators || {};
  //       const dates = response.data?.historicaldata || [];

  //       setHistorical(histData);
  //       setClosingPrices(closing);
  //       setIndicators(indi);
  //       setDateData(dates);
  //     } catch (err) {
  //       console.error("Error fetching historical:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchStockData();
  //   fetchLiveStock();
  //   fetchHistorical();
  // }, [nseCode]);
  // console.log("Live stock data", stock);

  // console.log("Stock by id", stockDataId);
  // console.log("Historical", historical);
  // const companyName = stockDataId?.companyName;
  // console.log("companyName", companyName);
  // const newStockId = stockDataId?.companyProfile?.peerCompanyList;
  // console.log("newStockId", newStockId);
  // const stockIdObject = newStockId?.find(
  //   (stock) => stock.companyName?.toLowerCase() === companyName?.toLowerCase()
  // );
  // const stockIdNse = stockIdObject?.tickerId;
  // console.log("stockIdNse", stockIdNse);
  // console.log("stockIdObjec", stockIdObject);
  // useEffect(() => {
  //   const fetchIntraday = async () => {
  //     if (!stockIdNse) return; // wait until we have tickerId

  //     try {
  //       setLoading(true);
  //       // const response = await axios.post("http://localhost:8000/api/intraday",
  //       const response = await axios.post(`${BASE_URL}/api/intraday`, {
  //         stock_id: stockIdNse,
  //       });
  //       setIntraday(response.data);
  //       console.log("Intraday Data:", response.data);
  //     } catch (err) {
  //       console.error("Error fetching intraday:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchIntraday();
  // }, [stockIdNse]);
  // const fetchAllSearchData = async (forceRefresh = false) => {
  //   if (!searchtext) return;
  //   const cacheKey = `search_${searchtext}_cache`;

  //   try {
  //     setLoading(true);

  //     // ✅ 1️⃣ Try cache first (unless forced)
  //     const cached = JSON.parse(localStorage.getItem(cacheKey));
  //     if (cached && !forceRefresh) {
  //       console.log(`✅ Using cached data for: ${searchtext}`);
  //       setDetail(cached.detail);
  //       setStock(cached.stock);
  //       setStockDataId(cached.stockDataId);
  //       setHistorical(cached.historical);
  //       setClosingPrices(cached.closingPrices);
  //       setIndicators(cached.indicators);
  //       setDateData(cached.dateData);
  //       setIntraday(cached.intraday);
  //       setLastFetched(cached.timestamp);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log(`🆕 Fetching new data for: ${searchtext}`);

  //     // ✅ 2️⃣ Fetch Stock Detail
  //     console.log("Fetching Stock Detail...");
  //     const response1 = await axios.get(`${BASE_URL}/api/stock`, {
  //       params: { stock_name: searchtext },
  //     });
  //     setDetail(response1.data);
  //     console.log("Details", response1.data);

  //     const nseCode = response1.data?.nse_scrip_code;
  //     console.log("Nsecode", nseCode);

  //     if (!nseCode) {
  //       console.warn("⚠️ No NSE code found, skipping dependent calls.");
  //       setLoading(false);
  //       return;
  //     }

  //     // ✅ 3️⃣ Fetch Live Stock
  //     console.log("Fetching Live Stock...");
  //     const response2 = await axios.post(`${BASE_URL}/api/nsedata`, {
  //       stock_symbols: [nseCode],
  //     });
  //     const liveStock = response2.data[nseCode];
  //     setStock(liveStock);
  //     console.log("Live stock data", liveStock);

  //     // ✅ 4️⃣ Fetch Stock Data by Symbol
  //     console.log("Fetching Stock Data...");
  //     const response3 = await axios.get(`${BASE_URL}/api/stockdata`, {
  //       params: { symbol: nseCode },
  //     });
  //     console.log("StockId data", response3.data);
  //     const detailData = response3.data;
  //     setStockDataId(response3.data);
  //     console.log("detail data", detailData);

  //     // ✅ Extract Stock ID
  //     const companyName = response3.data?.companyName;
  //     console.log("companyName", companyName);
  //     const newStockId = response3.data?.companyProfile?.peerCompanyList;
  //     console.log("newStockId", newStockId);

  //     try {
  //       console.log("Entering try block");
  //       const peers = detailData?.companyProfile?.peerCompanyList || [];
  //       console.log("Peers:", peers);

  //       if (peers.length === 0) {
  //         console.log("ℹ️ No peer companies found, skipping peer fetch");
  //       } else {
  //         console.log(`🔍 Fetching full data for ${peers.length} peers...`);

  //         const peerRequests = peers.map(async (peer) => {
  //           const peerName = peer.companyName?.trim();
  //           if (!peerName) return { name: "Unknown", data: null };

  //           try {
  //             const res = await axios.get(`${BASE_URL}/api/stock`, {
  //               params: { stock_name: peerName },
  //             });

  //             console.log(`📊 Response for ${peerName}:`, res.data);

  //             // Attach the full API response with the peer name
  //             return { name: peerName, peRatio: res.data.stats.peRatio };
  //           } catch (err) {
  //             console.error(
  //               `❌ Failed to fetch data for ${peerName}:`,
  //               err.message
  //             );
  //             return { name: peerName, peRatio: null };
  //           }
  //         });

  //         // Wait for all requests
  //         const peerResults = await Promise.all(peerRequests);
  //         setPeerPEData(peerResults);
  //         console.log("✅ Peer Full Data:", peerResults);
  //       }
  //     } catch (err) {
  //       console.error("⚠️ Error fetching peer data:", err);
  //     }
  //     const stockIdObject = newStockId?.find(
  //       (stock) =>
  //         stock.companyName?.toLowerCase() === companyName?.toLowerCase()
  //     );
  //     const stockIdNse = stockIdObject?.tickerId;
  //     console.log("stockIdNse", stockIdNse);

  //     // ✅ 5️⃣ Fetch Historical Data
  //     console.log("Fetching Historical Data...");
  //     const stockParam = nseCode?.includes("-") ? companyName : nseCode;

  //     console.log("📤 Fetching historical data for:", stockParam);
  //     const response4 = await axios.get(`${BASE_URL}/api/historical`, {
  //       params: {
  //         stock_name: stockParam,
  //         period: "6m",
  //         filter: "price",
  //       },
  //     });

  //     const histData = response4.data?.historicalData?.data || [];
  //     const closing = response4.data?.closingPrices || [];
  //     const indi = response4.data?.indicators || {};
  //     const dates = response4.data?.historicaldata || [];

  //     setHistorical(histData);
  //     setClosingPrices(closing);
  //     setIndicators(indi);
  //     setDateData(dates);
  //     console.log("Historical", histData);

  //     // ✅ 6️⃣ Fetch Intraday
  //     console.log("Fetching Intraday Data...");
  //     let intradayData = null;
  //     if (stockIdNse) {
  //       const response5 = await axios.post(`${BASE_URL}/api/intraday`, {
  //         stock_id: stockIdNse,
  //       });
  //       intradayData = response5.data;
  //       setIntraday(intradayData);
  //       console.log("Intraday Data:", intradayData);
  //     } else {
  //       console.warn("⚠️ No StockIdNSE found, skipping intraday fetch.");
  //     }

  //     // ✅ Cache All Data
  //     const cachePayload = {
  //       detail: response1.data,
  //       stock: liveStock,
  //       stockDataId: response3.data,
  //       historical: histData,
  //       closingPrices: closing,
  //       indicators: indi,
  //       dateData: dates,
  //       intraday: intradayData,
  //       timestamp: Date.now(),
  //     };

  //     localStorage.setItem(cacheKey, JSON.stringify(cachePayload));
  //     setLastFetched(Date.now());

  //     console.log(`💾 Cached data for ${searchtext}`);
  //   } catch (err) {
  //     console.error("❌ Error fetching search data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const fetchAllSearchData = async (forceRefresh = false) => {
  //   if (!searchtext) return;

  //   // ✅ Normalized cache key (to prevent mismatch)
  //   const cacheKey = `search_${searchtext.trim().toUpperCase()}_cache`;

  //   try {
  //     setLoading(true);

  //     // ✅ 1️⃣ Try cache first (unless force refresh)
  //     const cached = JSON.parse(localStorage.getItem(cacheKey));
  //     if (cached && !forceRefresh) {
  //       console.log(`✅ Using cached data for: ${searchtext}`);
  //       setDetail(cached.detail);
  //       setStock(cached.stock);
  //       setStockDataId(cached.stockDataId);
  //       setHistorical(cached.historical);
  //       setClosingPrices(cached.closingPrices);
  //       setIndicators(cached.indicators);
  //       setDateData(cached.dateData);
  //       setIntraday(cached.intraday);
  //       setLastFetched(cached.timestamp);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log(`🆕 Fetching new data for: ${searchtext}`);

  //     // ✅ 2️⃣ Fetch Stock Detail
  //     const response1 = await axios.get(`${BASE_URL}/api/stock`, {
  //       params: { stock_name: searchtext },
  //     });
  //     setDetail(response1.data);
  //     const nseCode = response1.data?.nse_scrip_code;
  //     console.log("NSE Code:", nseCode);

  //     if (!nseCode) {
  //       console.warn("⚠️ No NSE code found, skipping dependent calls.");
  //       setLoading(false);
  //       return;
  //     }

  //     // ✅ 3️⃣ Fetch Live Stock
  //     const response2 = await axios.post(`${BASE_URL}/api/nsedata`, {
  //       stock_symbols: [nseCode],
  //     });
  //     const liveStock = response2.data[nseCode];
  //     setStock(liveStock);
  //     console.log("Live Stock Data:", liveStock);

  //     // ✅ 4️⃣ Fetch Stock Data by Symbol
  //     const response3 = await axios.get(`${BASE_URL}/api/stockdata`, {
  //       params: { symbol: nseCode },
  //     });
  //     const detailData = response3.data;
  //     setStockDataId(detailData);

  //     const companyName = detailData?.companyName;
  //     const peerList = detailData?.companyProfile?.peerCompanyList || [];

  //     // ✅ 5️⃣ Fetch Peer Company Data
  //     try {
  //       if (peerList.length === 0) {
  //         console.log("ℹ️ No peer companies found.");
  //       } else {
  //         console.log(`🔍 Fetching ${peerList.length} peer companies...`);
  //         const peerRequests = peerList.map(async (peer) => {
  //           const peerName = peer.companyName?.trim();
  //           if (!peerName) return { name: "Unknown", peRatio: null };
  //           try {
  //             const res = await axios.get(`${BASE_URL}/api/stock`, {
  //               params: { stock_name: peerName },
  //             });
  //             return { name: peerName, peRatio: res.data.stats.peRatio };
  //           } catch (err) {
  //             console.error(`❌ Failed for ${peerName}:`, err.message);
  //             return { name: peerName, peRatio: null };
  //           }
  //         });
  //         const peerResults = await Promise.all(peerRequests);
  //         setPeerPEData(peerResults);
  //         console.log("✅ Peer Data:", peerResults);
  //       }
  //     } catch (err) {
  //       console.error("⚠️ Peer data error:", err);
  //     }

  //     const stockIdObject = peerList.find(
  //       (s) => s.companyName?.toLowerCase() === companyName?.toLowerCase()
  //     );
  //     const stockIdNse = stockIdObject?.tickerId;

  //     // ✅ 6️⃣ Fetch Historical Data
  //     const stockParam = nseCode.includes("-") ? companyName : nseCode;
  //     const response4 = await axios.get(`${BASE_URL}/api/historical`, {
  //       params: {
  //         stock_name: stockParam,
  //         period: "6m",
  //         filter: "price",
  //       },
  //     });

  //     const histData = response4.data?.historicalData?.data || [];
  //     const closing = response4.data?.closingPrices || [];
  //     const indi = response4.data?.indicators || {};
  //     const dates = response4.data?.historicaldata || [];

  //     setHistorical(histData);
  //     setClosingPrices(closing);
  //     setIndicators(indi);
  //     setDateData(dates);
  //     console.log("Historical Data:", histData);

  //     // ✅ 7️⃣ Fetch Intraday
  //     let intradayData = null;
  //     if (stockIdNse) {
  //       const response5 = await axios.post(`${BASE_URL}/api/intraday`, {
  //         stock_id: stockIdNse,
  //       });
  //       intradayData = response5.data;
  //       setIntraday(intradayData);
  //       console.log("Intraday Data:", intradayData);
  //     } else {
  //       console.warn("⚠️ No StockIdNSE found, skipping intraday fetch.");
  //     }

  //     // ✅ 8️⃣ Cache All Data (only after successful fetch)
  //     const cachePayload = {
  //       detail: response1.data,
  //       stock: liveStock,
  //       stockDataId: detailData,
  //       historical: histData,
  //       closingPrices: closing,
  //       indicators: indi,
  //       dateData: dates,
  //       intraday: intradayData,
  //       timestamp: Date.now(),
  //     };

  //     localStorage.setItem(cacheKey, JSON.stringify(cachePayload));
  //     setLastFetched(Date.now());
  //     console.log(`💾 Cached data for ${searchtext} with key: ${cacheKey}`);
  //   } catch (err) {
  //     console.error("❌ Error fetching search data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // ✅ Manual refresh handler
  // const handleRefresh = async () => {
  //   if (!searchtext) return;
  //   const cacheKey = `search_${searchtext}_cache`;
  //   localStorage.removeItem(cacheKey);
  //   console.log(`🔄 Refreshing data for ${searchtext}...`);
  //   await fetchAllSearchData(true);
  // };
  // useEffect(() => {
  //   if (searchtext) {
  //     fetchAllSearchData();
  //   }
  // }, [searchtext]);
  // const fetchAllSearchData = async (forceRefresh = false) => {
  //   if (!searchtext) return;

  //   const cacheKey = `search_${searchtext.trim().toUpperCase()}_cache`;

  //   try {
  //     setLoading(true);

  //     // ✅ 1️⃣ Try cache first
  //     const cached = JSON.parse(localStorage.getItem(cacheKey));
  //     if (cached && !forceRefresh) {
  //       console.log(`✅ Using cached data for: ${searchtext}`);
  //       setDetail(cached.detail);
  //       setStock(cached.stock);
  //       setStockDataId(cached.stockDataId);
  //       setHistorical(cached.historical);
  //       setClosingPrices(cached.closingPrices);
  //       setIndicators(cached.indicators);
  //       setDateData(cached.dateData);
  //       setIntraday(cached.intraday);
  //       setLastFetched(cached.timestamp);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log(`🆕 Fetching new data for: ${searchtext}`);

  //     // ✅ 2️⃣ Fetch stock details
  //     const response1 = await axios.get(`${BASE_URL}/api/stock`, {
  //       params: { stock_name: searchtext },
  //     });
  //     setDetail(response1.data);

  //     const nseCode = response1.data?.nse_scrip_code;
  //     if (!nseCode) {
  //       console.warn("⚠️ No NSE code found, skipping dependent calls.");
  //       setLoading(false);
  //       return;
  //     }

  //     // ✅ 3️⃣ Fetch live stock
  //     const response2 = await axios.post(`${BASE_URL}/api/nsedata`, {
  //       stock_symbols: [nseCode],
  //     });
  //     const liveStock = response2.data[nseCode];
  //     setStock(liveStock);

  //     // ✅ 4️⃣ Fetch detailed stock data
  //     const response3 = await axios.get(`${BASE_URL}/api/stockdata`, {
  //       params: { symbol: nseCode },
  //     });
  //     const detailData = response3.data;
  //     setStockDataId(detailData);

  //     const companyName = detailData?.companyName;
  //     const peerList = detailData?.companyProfile?.peerCompanyList || [];

  //     // ✅ 5️⃣ Fetch Peer Company Data
  //     try {
  //       if (peerList.length > 0) {
  //         console.log(`🔍 Fetching ${peerList.length} peer companies...`);
  //         const peerRequests = peerList.map(async (peer) => {
  //           const peerName = peer.companyName?.trim();
  //           if (!peerName) return { name: "Unknown", peRatio: null };

  //           try {
  //             const res = await axios.get(`${BASE_URL}/api/stock`, {
  //               params: { stock_name: peerName },
  //             });
  //             return { name: peerName, peRatio: res.data.stats.peRatio };
  //           } catch {
  //             return { name: peerName, peRatio: null };
  //           }
  //         });

  //         const peerResults = await Promise.all(peerRequests);
  //         setPeerPEData(peerResults);
  //       }
  //     } catch (err) {
  //       console.error("⚠️ Error fetching peer data:", err);
  //     }

  //     // ✅ 6️⃣ Historical Data
  //     const stockParam = nseCode.includes("-") ? companyName : nseCode;
  //     const response4 = await axios.get(`${BASE_URL}/api/historical`, {
  //       params: { stock_name: stockParam, period: "6m", filter: "price" },
  //     });

  //     const histData = response4.data?.historicalData?.data || [];
  //     const closing = response4.data?.closingPrices || [];
  //     const indi = response4.data?.indicators || {};
  //     const dates = response4.data?.historicaldata || [];

  //     setHistorical(histData);
  //     setClosingPrices(closing);
  //     setIndicators(indi);
  //     setDateData(dates);

  //     // ✅ 7️⃣ Intraday Data
  //     let intradayData = null;
  //     const stockIdObject = peerList.find(
  //       (s) => s.companyName?.toLowerCase() === companyName?.toLowerCase()
  //     );
  //     const stockIdNse = stockIdObject?.tickerId;

  //     if (stockIdNse) {
  //       const response5 = await axios.post(`${BASE_URL}/api/intraday`, {
  //         stock_id: stockIdNse,
  //       });
  //       intradayData = response5.data;
  //       setIntraday(intradayData);
  //     }

  //     // ✅ 8️⃣ Save everything in cache
  //     const cachePayload = {
  //       detail: response1.data,
  //       stock: liveStock,
  //       stockDataId: detailData,
  //       historical: histData,
  //       closingPrices: closing,
  //       indicators: indi,
  //       dateData: dates,
  //       intraday: intradayData,
  //       timestamp: Date.now(),
  //     };

  //     localStorage.setItem(cacheKey, JSON.stringify(cachePayload));
  //     setLastFetched(Date.now());
  //     console.log(`💾 Cached data for ${searchtext}`);
  //   } catch (err) {
  //     console.error("❌ Error fetching search data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ Refresh handler (clear cache + force fetch)
  // const handleRefresh = async () => {
  //   if (!searchtext) return;
  //   const cacheKey = `search_${searchtext.trim().toUpperCase()}_cache`;
  //   localStorage.removeItem(cacheKey);
  //   console.log(`🔄 Refreshing data for ${searchtext}...`);
  //   await fetchAllSearchData(true); // force new fetch
  // };

  // // ✅ Load data (either from cache or API) on mount / when searchtext changes
  // useEffect(() => {
  //   if (searchtext) {
  //     fetchAllSearchData();
  //   }
  // }, [searchtext]);
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  const fetchAllSearchData = useCallback(
    async (forceRefresh = false) => {
      if (!searchtext) return;

      const cacheKey = `search_${searchtext.trim().toUpperCase()}_cache`;

      try {
        setLoading(true);

        // ✅ 1️⃣ Check global in-memory cache
        if (stockCache[cacheKey] && !forceRefresh) {
          console.log(`✅ Loaded from in-memory cache for: ${searchtext}`);
          const cached = stockCache[cacheKey];
          setDetail(cached.detail);
          setStock(cached.stock);
          setStockDataId(cached.stockDataId);
          setHistorical(cached.historical);
          setClosingPrices(cached.closingPrices);
          setIndicators(cached.indicators);
          setDateData(cached.dateData);
          setIntraday(cached.intraday);
          setLastFetched(cached.timestamp);
          setLoading(false);
          return;
        }

        // ✅ 2️⃣ Check localStorage cache
        const cachedLocal = JSON.parse(localStorage.getItem(cacheKey));
        console.log("Cached data", cachedLocal);
        if (cachedLocal && !forceRefresh) {
          console.log(`✅ Loaded from localStorage for: ${searchtext}`);
          stockCache[cacheKey] = cachedLocal; // store in memory
          setDetail(cachedLocal.detail);
          setStock(cachedLocal.stock);
          setStockDataId(cachedLocal.stockDataId);
          setHistorical(cachedLocal.historical);
          setClosingPrices(cachedLocal.closingPrices);
          setIndicators(cachedLocal.indicators);
          setDateData(cachedLocal.dateData);
          setIntraday(cachedLocal.intraday);
          setLastFetched(cachedLocal.timestamp);
          setTargetPrice(cachedLocal.targetPrice);
          setLoading(false);
          return;
        }

        // ✅ 3️⃣ No cache available or force refresh → fetch all data
        console.log(`🆕 Fetching new data for: ${searchtext}`);

        // 🟢 Stock details
        const response1 = await axios.get(`${BASE_URL}/api/stock`, {
          params: { stock_name: searchtext },
        });
        setDetail(response1.data);
        const nseCode = response1.data?.nse_scrip_code;
        if (!nseCode) {
          console.warn("⚠️ No NSE code found, skipping dependent calls.");
          setLoading(false);
          return;
        }

        // 🟢 Stock data by symbol
        const response2 = await axios.get(`${BASE_URL}/api/stockdata`, {
          params: { symbol: nseCode },
        });
        const detailData = response2.data;
        setStockDataId(detailData);

        const companyName = detailData?.companyName;

        // 🟢 Peer company data
        try {
          const peers = detailData?.companyProfile?.peerCompanyList || [];
          if (peers.length > 0) {
            console.log(`🔍 Fetching ${peers.length} peers...`);
            const peerRequests = peers.map(async (peer) => {
              const peerName = peer.companyName?.trim();
              if (!peerName) return { name: "Unknown", peRatio: null };
              try {
                const res = await axios.get(`${BASE_URL}/api/stock`, {
                  params: { stock_name: peerName },
                });
                return { name: peerName, peRatio: res.data.stats.peRatio };
              } catch {
                return { name: peerName, peRatio: null };
              }
            });
            const peerResults = await Promise.all(peerRequests);
            setPeerPEData(peerResults);
          }
        } catch (err) {
          console.error("⚠️ Error fetching peer data:", err);
        }

        // 🟢 Historical data
        const stockParam = nseCode.includes("-") ? companyName : nseCode;
        const response3 = await axios.get(`${BASE_URL}/api/historical`, {
          params: { stock_name: stockParam, period: "6m", filter: "price" },
        });
        const histData = response3.data?.historicalData?.data || [];
        const closing = response3.data?.closingPrices || [];
        const indi = response3.data?.indicators || {};
        const dates = response3.data?.historicaldata || [];
        setHistorical(histData);
        setClosingPrices(closing);
        setIndicators(indi);
        setDateData(dates);

        // 🟢 Live NSE stock
        const response4 = await axios.post(`${BASE_URL}/api/nsedata`, {
          stock_symbols: [nseCode],
        });
        const liveStock = response4.data[nseCode];
        setStock(liveStock);

        // 🟢 Intraday data
        let intradayData = null;
        const stockIdObject = detailData?.companyProfile?.peerCompanyList?.find(
          (s) => s.companyName?.toLowerCase() === companyName?.toLowerCase(),
        );
        const stockIdNse = stockIdObject?.tickerId;
        if (stockIdNse) {
          const response5 = await axios.post(`${BASE_URL}/api/intraday`, {
            stock_id: stockIdNse,
          });
          intradayData = response5.data;
          setIntraday(intradayData);
        }
        const targetRes = await axios.get(`${BASE_URL}/api/stocktarget`, {
          params: { symbol: nseCode },
        });
        setTargetPrice(targetRes.data);
        // 🟢 Cache result both in-memory and localStorage
        const cachePayload = {
          detail: response1.data,
          stock: liveStock,
          stockDataId: detailData,
          historical: histData,
          closingPrices: closing,
          indicators: indi,
          dateData: dates,
          intraday: intradayData,
          targetPrice: targetRes.data,
          timestamp: Date.now(),
        };
        stockCache[cacheKey] = cachePayload;
        localStorage.setItem(cacheKey, JSON.stringify(cachePayload));
        setLastFetched(Date.now());

        console.log(`💾 Cached data for ${searchtext}`);
      } catch (err) {
        console.error("❌ Error fetching search data:", err);
        setError("Api failed!");
      } finally {
        setLoading(false);
      }
    },
    [searchtext],
  );

  // ✅ Manual refresh
  const handleRefresh = async () => {
    setError(null);
    if (!searchtext) return;
    const cacheKey = `search_${searchtext.trim().toUpperCase()}_cache`;
    delete stockCache[cacheKey];
    localStorage.removeItem(cacheKey);
    console.log(`🔄 Manually refreshing data for ${searchtext}...`);
    await fetchAllSearchData(true);
  };

  // ✅ Load data on mount / when searchtext changes
  useEffect(() => {
    if (searchtext) {
      fetchAllSearchData();
      setLastUpdated(formatTimestamp());
    }
  }, [searchtext, fetchAllSearchData]);

  const nseCode = detail?.nse_scrip_code;
  console.log("NseCode", nseCode);
  const companyName = detail?.name;
  console.log("companyName", companyName);
  // const peerList = detail?.companyProfile?.peerCompanyList;
  const peerList = stockDataId?.companyProfile?.peerCompanyList.filter(
    (stock) => stock.companyName.toLowerCase() !== companyName.toLowerCase(),
  );

  console.log("Peer List", peerList);
  console.log("Intraday", intraday);
  const intradayIndicators = intraday?.indicators;
  console.log("IntradayIndi", intradayIndicators);
  const peRatio = detail?.stats?.peRatio;
  const faceValue = detail?.stats?.faceValue;
  const target_price = targetPrice?.priceTarget?.Mean;
  console.log("Final target price", target_price);
  const projected_change = (
    ((target_price - stock?.ltp) / stock?.ltp) *
    100
  ).toFixed(2);
  console.log("Projected change", projected_change);
  console.log("Peer company PE Ratio", peerPEData);
  const mergedPeers = peerList?.map((peer) => {
    // find the matching peer in peerPEData
    const match = peerPEData?.find(
      (p) =>
        p.name?.trim().toLowerCase() === peer.companyName?.trim().toLowerCase(),
    );

    // attach peRatio if found, else keep as "N/A"
    return {
      ...peer,
      peRatio: match ? match.peRatio : "N/A",
    };
  });
  console.log("Matched", mergedPeers);

  console.log("Pe", peRatio);
  console.log("fv", faceValue);
  const macdChartData =
    Array.isArray(indicators.macd) &&
    indicators.macd.map((row, i) => ({
      date:
        dateData[i + (dateData.length - indicators.macd.length)]?.date || null,

      MACD: row.MACD ?? 0,
      signal: row.signal ?? 0,
      histogram: row.histogram ?? 0,
    }));
  // Minute data for chart
  const histoMin = intraday?.historicalData;
  console.log("histoMin", histoMin);
  const macdChartDataMin =
    Array.isArray(intradayIndicators?.macd) &&
    intradayIndicators?.macd.map((row, i) => ({
      date:
        histoMin?.[i + (histoMin?.length - intradayIndicators?.macd?.length)]
          ?.date || i + 1,
      MACD: row.MACD ?? 0,
      signal: row.signal ?? 0,
      histogram: row.histogram ?? 0,
    }));

  console.log("Indicators", indicators);
  console.log("Historical", historical);
  console.log("MACD Chart Data:", macdChartData);
  console.log("Macr chart dat", macdChartDataMin);

  let rsiStatus = "N/A";
  let latestRSI = null;

  if (indicators.rsi && indicators.rsi.length > 0) {
    latestRSI = indicators.rsi.slice(-1)[0];
    if (latestRSI >= 70) rsiStatus = "Overbought";
    else if (latestRSI <= 30) rsiStatus = "Oversold";
    else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
    else rsiStatus = "Neutral-Bearish";
  }

  // ---- MACD ----
  let macdStatus = "N/A";
  let latestMACD = null;

  if (indicators.macd && indicators.macd.length > 0) {
    latestMACD = indicators.macd.slice(-1)[0];
    if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
      macdStatus = "Bullish";
    } else if (
      latestMACD.MACD < latestMACD.signal &&
      latestMACD.histogram < 0
    ) {
      macdStatus = "Bearish";
    } else {
      macdStatus = "Neutral";
    }
  }

  let combined = "Neutral / Sideways";
  let combinedColor = "#e6eef3";
  if (rsiStatus.includes("Bullish") && macdStatus === "Bullish") {
    combined = "📈 Bullish momentum confirmed";
    combinedColor = "#2fd18a";
  } else if (rsiStatus.includes("Bearish") && macdStatus === "Bearish") {
    combined = "📉 Bearish momentum confirmed";
    combinedColor = "#f87171";
  }
  // const getInterpretation = (indicators) => {
  //   if (
  //     !indicators.macd ||
  //     indicators.macd.length === 0 ||
  //     !indicators.rsi ||
  //     indicators.rsi.length === 0
  //   ) {
  //     return { result: "⚠️ Insufficient data", color: "#e6eef3" };
  //   }

  //   const latestMACD = indicators.macd.slice(-1)[0];
  //   const latestRSI = indicators.rsi.slice(-1)[0];

  //   if (
  //     latestRSI > 50 &&
  //     latestMACD.MACD > latestMACD.signal &&
  //     latestMACD.histogram > 0
  //   ) {
  //     return {
  //       result: "📈 Bullish momentum confirmed (RSI & MACD aligned)",
  //       color: "#2fd18a", // green
  //     };
  //   } else if (
  //     latestRSI < 50 &&
  //     latestMACD.MACD < latestMACD.signal &&
  //     latestMACD.histogram < 0
  //   ) {
  //     return {
  //       result: "📉 Bearish momentum confirmed (RSI & MACD aligned)",
  //       color: "#f87171", // red
  //     };
  //   } else if (
  //     (latestRSI > 50 &&
  //       latestMACD.MACD < latestMACD.signal &&
  //       latestMACD.histogram < 0) ||
  //     (latestRSI < 50 &&
  //       latestMACD.MACD > latestMACD.signal &&
  //       latestMACD.histogram > 0)
  //   ) {
  //     return {
  //       result: "⚠️ Divergence detected (RSI and MACD conflict)",
  //       color: "#fbbf24", // amber/yellow
  //     };
  //   } else {
  //     return {
  //       result: "⚖️ Neutral / Sideways market",
  //       color: "#e6eef3", // neutral grey
  //     };
  //   }
  // };
  const getInterpretation = (indicators) => {
    // --- SAFETY CHECK ---
    if (
      !indicators ||
      !Array.isArray(indicators.macd) ||
      !Array.isArray(indicators.rsi) ||
      indicators.macd.length === 0 ||
      indicators.rsi.length === 0
    ) {
      return {
        result: " Insufficient data",
        color: "#fbbf24",
        prediction: "neutral",
      }; // gray
    }

    // --- GET LATEST VALUES ---
    const latestMACD = indicators.macd.slice(-1)[0];
    const latestRSI = indicators.rsi.slice(-1)[0];

    // --- DETERMINE RSI STATUS ---
    let rsiStatus = "Neutral";
    if (latestRSI >= 70) rsiStatus = "Overbought";
    else if (latestRSI <= 30) rsiStatus = "Oversold";
    else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
    else rsiStatus = "Neutral-Bearish";

    // --- DETERMINE MACD STATUS ---
    let macdStatus = "Neutral";
    if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
      macdStatus = "Bullish";
    } else if (
      latestMACD.MACD < latestMACD.signal &&
      latestMACD.histogram < 0
    ) {
      macdStatus = "Bearish";
    }

    // --- COMBINED INTERPRETATION ---
    // RSI + MACD agree strongly → high-confidence momentum
    if (
      (rsiStatus.includes("Bullish") || latestRSI > 55) &&
      macdStatus === "Bullish"
    ) {
      return {
        result: "📈 Strong Bullish Momentum (RSI & MACD aligned)",
        color: "#2fd18a",
        prediction: "Buy", // green
      };
    }

    if (
      (rsiStatus.includes("Bearish") || latestRSI < 45) &&
      macdStatus === "Bearish"
    ) {
      return {
        result: "Strong Bearish Momentum (RSI & MACD aligned)",
        color: "#f87171",
        prediction: "Sell", // red
      };
    }

    // --- DIVERGENCE CASES ---
    // RSI uptrend but MACD downtrend or vice versa
    if (
      (latestRSI > 50 &&
        latestMACD.MACD < latestMACD.signal &&
        latestMACD.histogram < 0) ||
      (latestRSI < 50 &&
        latestMACD.MACD > latestMACD.signal &&
        latestMACD.histogram > 0)
    ) {
      return {
        result:
          "Divergence detected (RSI and MACD conflict) - Possible reversal ahead",
        color: "#fbbf24",
        prediction: "Neutral", // yellow
      };
    }

    // --- EXTREME CONDITIONS ---
    if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
      return {
        result: " Overbought! Bullish but nearing exhaustion",
        color: "#f59e0b",
        prediction: "Sell",
        // amber-orange
      };
    }

    if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
      return {
        result: " Oversold! Bearish but near potential rebound zone",
        color: "#60a5fa",
        prediction: "Buy", // blue
      };
    }

    // --- NEUTRAL / SIDEWAYS ---
    return {
      result: " Neutral / Sideways Market (No strong signal)",
      color: "#9ca3af",
      prediction: "Neutral", // grayish neutral
    };
  };

  const { result, color, prediction } = getInterpretation(indicators);
  const {
    result: result1,
    color: color1,
    prediction: prediction1,
  } = getInterpretation(intradayIndicators);
  console.log("Result", result);

  let resultColor = "#e6eef3"; // default neutral

  if (result?.includes("Bullish")) {
    resultColor = "#2fd18a"; // green
  } else if (result?.includes("Bearish")) {
    resultColor = "#f87171"; // red
  } else if (result?.includes("Divergence")) {
    resultColor = "#fbbf24"; // amber/yellow
  } else {
    resultColor = "#e6eef3"; // neutral grey
  }
  // const formatVolume = (volume) => {
  //   return typeof volume === "string"
  //     ? Number(volume).toLocaleString()
  //     : volume.toLocaleString();
  // };
  const formatVolume = (volume) => {
    if (volume == null) return "-";

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };
  const selectedData =
    timeFrame === "min"
      ? Array.isArray(macdChartDataMin)
        ? macdChartDataMin
        : []
      : Array.isArray(macdChartData)
        ? macdChartData
        : [];
  const hasData =
    stock || detail || historical?.length > 0 || indicators?.rsi?.length > 0;
  console.log("Hasdata", hasData);
  const data = pcrStore[nseCode];
  console.log("Data", data);
  useEffect(() => {
    if (!nseCode) return; // Wait until stockCode exists

    console.log("📌 Fetching PCR for:", nseCode);
    loadData(nseCode);
  }, [nseCode]);

  useEffect(() => {
    if (nseCode) {
      fetchBySymbol(nseCode);
    }
  }, [nseCode]);
  console.log("Data from pcrcontext", data);
  const options = data?.filtered?.data;
  const ceOI =
    options &&
    options
      .filter((item) => item?.CE)
      .reduce((sum, item) => sum + (item?.CE?.openInterest || 0), 0);
  const peOI =
    options &&
    options
      .filter((item) => item.PE)
      .reduce((sum, item) => sum + (item.PE.openInterest || 0), 0);
  // const pcr = (peOI / ceOI).toFixed(2);
  console.log("Pcr", pcr);
  return (
    <>
      <div>
        {/* <div style={{ textAlign: "right", margin: "10px" }}>
          <button
            className="rec-btn"
            onClick={handleRefresh}
            disabled={loading}
          >
            {loading ? "Refreshing..." : "Refresh Data"}
          </button>
        </div> */}
        <div className="last-updated-head">
          {lastUpdated && <span>As on {lastUpdated}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>

        {loading ? (
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "700",
              // color: "white",
              display: "flex",

              gap: "1rem",
            }}
          >
            Fetching Live data..{" "}
            <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
              <FaSpinner />
            </span>
          </p>
        ) : error && !hasData ? (
          <div>
            <p
              style={{
                fontSize: "1rem",
                fontWeight: "700",
                color: "white",
                display: "flex",
                gap: "1rem",
              }}
            >
              Failed to load data refresh again..{" "}
            </p>
          </div>
        ) : (
          <>
            <div className="stock-detail-card">
              {/* <div className="stock-extra-table-container">
                <div className="stock-extra-cards">
                  {stock ? (
                    <>
                      <div className="stock-extra-card company-card">
                        <div className="company-left">
                         
                          <div className="company-text">
                            <p className="card-label">Company</p>
                            <p className="card-value">{companyName}</p>
                          </div>
                        </div>
                        <div className="company-left">
                         
                          <div className="company-text">
                            <p className="card-label">NSE CODE</p>
                            <p className="card-value">{nseCode}</p>
                          </div>
                        </div>

                        <div className="company-right">
                          <p
                            className="result-value
                    
                    "
                            style={{
                              color: timeFrame === "min" ? color1 : color,
                            }}
                          >
                            {timeFrame === "min" ? result1 : result}
                          </p>
                        </div>
                        <div className="company-right">
                          <button
                            className="view-more-btn-stock"
                            style={{
                              backgroundColor:
                                timeFrame === "min" ? color1 : color,
                            }}
                          >
                            {timeFrame === "min" ? prediction1 : prediction}
                          </button>
                         
                        </div>
                      </div>

                     
                      <div className="extra-cards-grid grid-desktop">
                        
                        <div className="stock-extra-card">
                          <div className="card-left">
                           
                            <p className="card-label">LTP</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock.ltp}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                           

                            <p className="card-label">RSI</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {latestRSI?.toFixed(2) > 0 ? (
                             
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color: latestRSI > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestRSI?.toFixed(2)}
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                           

                            <p className="card-label">Open</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock.open}</p>
                          </div>
                        </div>

                     
                        <div className="stock-extra-card">
                          <div className="card-left">
                           
                            <p className="card-label">Low</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock.low}</p>
                          </div>
                        </div>

                        <div
                          className={`stock-extra-card ${
                            stock.day_change_percent >= 0
                              ? "positive"
                              : "negative"
                          }`}
                        >
                          <div className="card-left">
                            <p className="card-label">% Change</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {stock.day_change_percent > 0 ? (
                             
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p className="card-value">
                              {stock.day_change_percent?.toFixed(2)}%
                            </p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                          
                            <p className="card-label">MACD</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {latestMACD?.MACD > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  latestMACD?.MACD > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestMACD?.MACD?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                       
                        <div className="stock-extra-card">
                          <div className="card-left">
                          

                            <p className="card-label">Close</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">{stock.close}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                           
                            <p className="card-label">High</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock.high}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Upside</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {projected_change > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}

                            <p
                              className="card-value"
                              style={{
                                color:
                                  projected_change > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {projected_change}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Target Price</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{target_price}</p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                           
                            <p className="card-label">Volume</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              {formatVolume(stock.volume)}
                            </p>
                          </div>
                        </div>

                        {peRatio && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                            
                              <p className="card-label">PE Ratio</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{peRatio}</p>
                            </div>
                          </div>
                        )}
                        {faceValue && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                             
                              <p className="card-label">Face Value</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{faceValue}</p>
                            </div>
                          </div>
                        )}
                       
                        {pcr && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">PCR</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{pcr}</p>
                            </div>
                          </div>
                        )}
                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/pcr/${nseCode}`);
                          }}
                        >
                          <div className="card-left">
                            <p className="card-label">Option Chain</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <FaChevronRight />
                            </p>
                          </div>
                        </div>
                        <div
                          className="stock-extra-card"
                          style={{ backgroundColor: "#2fd18a", color: "white" }}
                        >
                          <button
                            className="view-more-btn-stock"
                            style={{
                              width: "100%",
                              fontSize: "1.2rem",
                              fontWeight: "700",
                              color: "white",
                              background: "inherit",
                              border: "none",
                            }}
                          >
                            Add to Watchlist
                          </button>
                        </div>
                      </div>
                      <div className="extra-cards-grid grid-mobile">
                        <div className="stock-extra-card">
                          <div className="card-left">
                           
                            <p className="card-label">LTP</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.ltp}</p>
                          </div>
                        </div>
                        <div
                          className={`stock-extra-card ${
                            stock?.percent_change >= 0 ? "positive" : "negative"
                          }`}
                        >
                          <div className="card-left">
                          
                            <p className="card-label">% Change</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {stock.day_change_percent > 0 ? (
                             
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  stock?.day_change_percent > 0
                                    ? "#2fd18a"
                                    : "#f87171",
                              }}
                            >
                              {stock?.day_change_percent?.toFixed(2)}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Open</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.open}</p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                           

                            <p className="card-label">Close</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.close}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                           
                            <p className="card-label">Low</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.low}</p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                          
                            <p className="card-label">High</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.high}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                           

                            <p className="card-label">RSI</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {latestRSI?.toFixed(2) > 0 ? (
                             
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color: latestRSI > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestRSI?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">MACD</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {latestMACD?.MACD > 0 > 0 ? (
                              // <FaChartLine className="card-icon" />
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  latestMACD?.MACD > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestMACD?.MACD?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                       
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">~Upside</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex" }}
                          >
                            {projected_change > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}

                            <p
                              className="card-value"
                              style={{
                                color:
                                  projected_change > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {projected_change}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Target Price</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{target_price}</p>
                          </div>
                        </div>

                       
                        <div className="stock-extra-card">
                          <div className="card-left">
                            
                          </div>
                          <div className="card-right">
                            
                            <p className="card-value">
                              {formatVolume(stock?.volume)}
                            </p>
                          </div>
                        </div>

                       
                        {peRatio && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                             
                              <p className="card-label">PE Ratio</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{peRatio}</p>
                            </div>
                          </div>
                        )}

                       
                        {faceValue && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              
                              <p className="card-label">Face Value</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{faceValue}</p>
                            </div>
                          </div>
                        )}
                       
                        {pcr && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                             
                              <p className="card-label">PCR</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{pcr}</p>
                            </div>
                          </div>
                        )}
                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/pcr/${nseCode}`);
                          }}
                        >
                          <div className="card-left">
                            <p className="card-label">Option Chain</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <FaChevronRight />
                            </p>
                          </div>
                        </div>
                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                        >

                          <div className="card-left">
                            <p className="card-label">Add to Watchlist</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <MdOutlineNoteAdd />
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "white",
                        display: "flex",
                        gap: "1rem",
                      }}
                    >
                      Fetching Live data..{" "}
                      <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
                        <FaSpinner />
                      </span>
                    </p>
                  )}
                </div>
              </div> */}
              <div className="analysis-container">
                <div className="analysis-header">
                  <div>
                    <h2 className="stock-title">{companyName}</h2>
                    <span className="stock-tag">{nseCode}</span>
                  </div>

                  <div className="action-buttons">
                    {/* <button className="btn-buy">Buy</button>
                    <button className="btn-sell">Sell</button>
                    <button className="btn-hold">Hold</button> */}
                    <button
                      className="btn-star"
                      onClick={() => navigate(`/stocktest/${nseCode}`)}
                    >
                      ★
                    </button>
                  </div>
                </div>
                <div
                  className="insight-box"
                  style={{
                    borderLeft:
                      timeFrame === "min"
                        ? `4px solid ${color1}`
                        : `4px solid ${color}`,
                  }}
                >
                  <p className="insight-head">Phro Trader Insights</p>
                  <div className="sub-insight">
                    <div
                      className="insight-text"
                      style={{
                        color: timeFrame === "min" ? color1 : color,
                      }}
                    >
                      {timeFrame === "min" ? result1 : result}
                    </div>
                    <button
                      className="insight-tag "
                      style={{
                        backgroundColor: timeFrame === "min" ? color1 : color,
                        color: "white",
                      }}
                    >
                      {timeFrame === "min" ? prediction1 : prediction}
                    </button>
                  </div>
                </div>
                <div className="price-summary">
                  <div className="price-chip">
                    <p className="label">LTP</p>
                    <h3 className="value">₹{stock?.ltp}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">% Change</p>
                    <h3
                      className="value "
                      style={{
                        color:
                          stock?.day_change_percent > 0 ? "#249966" : "#f87171",
                      }}
                    >
                      {stock?.day_change_percent >= 0
                        ? `+${stock?.day_change_percent?.toFixed(2)}%`
                        : `${stock?.day_change_percent?.toFixed(2)}%`}
                    </h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">Open</p>
                    <h3 className="value">₹{stock?.open}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">Close</p>
                    <h3 className="value">₹{stock?.close}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">Low</p>
                    <h3 className="value">₹{stock?.low}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">High</p>
                    <h3 className="value">₹{stock?.high}</h3>
                  </div>
                </div>

                <div className="factor-wrapper">
                  <div className="factor-box">
                    <h4>Technical Factors</h4>
                    <div className="inner-factor-box">
                      <div className="factor-row">
                        <p>RSI</p>
                        <span
                          style={{
                            color: latestRSI > 0 ? "#249966" : "#f87171",
                          }}
                        >
                          {" "}
                          {latestRSI?.toFixed(2)}
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>MACD</p>
                        <span
                          className="positive"
                          style={{
                            color:
                              latestMACD?.MACD?.toFixed(2) > 0
                                ? "#249966"
                                : "#f87171",
                          }}
                        >
                          {latestMACD?.MACD?.toFixed(2)}
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>Volume</p>
                        <span> {formatVolume(stock?.volume)}</span>
                        {/* <span>{formatVolume(stock?.volume)}</span> */}
                      </div>
                      <div className="factor-row">
                        <p>PCR</p>
                        <span>{pcr?.value}</span>
                      </div>
                    </div>
                  </div>

                  <div className="factor-box">
                    <h4>Fundamental Factors</h4>
                    <div className="inner-factor-box">
                      <div className="factor-row">
                        <p>% Upside</p>
                        <span
                          className="positive"
                          style={{
                            color: projected_change > 0 ? "#249966" : "#f87171",
                          }}
                        >
                          {" "}
                          {projected_change}%
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>Target Price</p>
                        <span>₹{target_price}</span>
                      </div>
                      <div className="factor-row">
                        <p>P/E Ratio</p>
                        <span>{peRatio}</span>
                      </div>
                      <div className="factor-row">
                        <p>Face Value</p>
                        <span>₹{faceValue}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="option-chain-div
                "
                >
                  <p>Option Chain</p>
                  <button
                    className="rec-btn"
                    // onClick={() => {
                    //   navigate(`/pcr/${nseCode}`);
                    // }}
                    onClick={() => {
                      navigate(`/optionpage/${nseCode}`);
                    }}
                  >
                    View Option Chain
                  </button>
                </div>
              </div>
            </div>

            {macdChartData && macdChartData.length > 0 && (
              <div className="macd-chart-graph">
                <div className="chart-top-heading">
                  <h3
                  // style={{
                  //   color: "#fff",
                  //   fontWeight: "bold",
                  //   fontSize: "1.5rem",
                  //   marginLeft: "1.5rem",
                  // }}
                  >
                    📊 MACD Line, Signal & Histogram
                  </h3>
                  <div className="chart-select">
                    <label
                    // style={{
                    //   fontSize: "1rem",
                    //   fontWeight: "700",
                    //   color: "white",
                    //   marginRight: "10px",
                    // }}
                    >
                      Interval
                    </label>
                    <select
                      name=""
                      id=""
                      value={timeFrame}
                      onChange={(e) => setTimeFrame(e.target.value)}
                      style={{
                        background: "inherit",
                        // color: "white",
                        color: "black",
                        fontWeight: "600",
                        boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
                        padding: "5px 7px",
                        borderRadius: "10px",
                      }}
                    >
                      <option value="min">Minute</option>
                      <option value="day">Day</option>
                    </select>
                  </div>
                </div>
                <ResponsiveContainer width="100%" height={300}>
                  <ComposedChart data={selectedData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" />

                    {/* X-Axis */}
                    {/* <XAxis
                dataKey="date"
                tickFormatter={(date) => {
                  const d = parseISO(date);

                  if (format(d, "dd") === "01") {
                    return format(d, "MMM");
                  }
                  return "";
                }}
                tick={{ fill: "#fff", fontWeight: "bold" }}
                axisLine={{ stroke: "#fff" }}
                tickLine={{ stroke: "#fff" }}
              /> */}
                    <XAxis
                      dataKey="date"
                      tickFormatter={(date, index) => {
                        if (!date) return "";

                        try {
                          const hasTime = date.includes(":");
                          const d = new Date(date.replace(" ", "T")); // ensures consistent parsing

                          if (hasTime) {
                            // ⏱ Case 1: Intraday data → show time every 30 minutes (roughly index % 15)
                            return index % 15 === 0
                              ? d.toLocaleTimeString("en-IN", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })
                              : "";
                          } else {
                            // 📅 Case 2: Daily data → show date every 10 days
                            return index % 10 === 0
                              ? d.toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                })
                              : "";
                          }
                        } catch {
                          return "";
                        }
                      }}
                      tick={{
                        // fill: "#fff",
                        fontWeight: "bold",
                        fontSize: 10,
                      }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    />

                    {/* Y-Axis */}
                    <YAxis
                      tick={{
                        // fill: "#fff",

                        fontWeight: "bold",
                        fontSize: 10,
                      }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    />

                    {/* Tooltip */}
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#1f2937",
                        border: "none",
                        color: "#fff",
                      }}
                      labelFormatter={(label) => {
                        try {
                          if (!label) return "";
                          const hasTime = label.includes(":");
                          const d = new Date(label.replace(" ", "T"));
                          if (isNaN(d.getTime())) return label;

                          if (hasTime) {
                            // ⏱ Intraday case → show date + time
                            return d.toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            });
                          } else {
                            // 📅 Daily case → show only date
                            return d.toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            });
                          }
                        } catch (err) {
                          return label;
                        }
                      }}
                      labelStyle={{ color: "#fff", fontWeight: "bold" }}
                      itemStyle={{ color: "#fff" }}
                    />

                    {/* <Tooltip
                labelFormatter={(label) => {
                  // label is your `date` string, e.g. "2025-10-03 09:16:00"
                  const d = parse(label, "yyyy-MM-dd HH:mm:ss", new Date());
                  return format(d, "dd MMM yyyy, HH:mm");
                  // Example: "03 Oct 2025, 09:16"
                }}
                contentStyle={{ backgroundColor: "#1e1e1e", color: "#fff" }}
              /> */}

                    <Legend wrapperStyle={{ fontWeight: "bold" }} />

                    {/* Histogram bars */}
                    <Bar
                      dataKey="histogram"
                      name="Histogram"
                      barSize={20}
                      shape={(props) => {
                        const { x, y, width, height, value } = props;
                        return (
                          <rect
                            x={x}
                            y={value >= 0 ? y : y - height}
                            width={width}
                            height={Math.abs(height)}
                            fill={value >= 0 ? "#2fd18a" : "#f87171"}
                          />
                        );
                      }}
                    />

                    {/* MACD Line */}
                    <Line
                      type="monotone"
                      dataKey="MACD"
                      stroke="#2563eb"
                      strokeWidth={2}
                      dot={false}
                      name="MACD"
                    />

                    {/* Signal Line */}
                    <Line
                      type="monotone"
                      dataKey="signal"
                      stroke="#f59e0b"
                      strokeWidth={2}
                      dot={false}
                      name="Signal"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            )}

            {/* <div className="peer-section">
              <h2 className="peer-title">Peer Companies for {companyName}</h2>

              <div className="peer-grid">
                {mergedPeers?.map((item) => (
                  <div
                    key={item?.tickerId}
                    className="peer-card"
                    onClick={() => navigate(`/stock/${item.tickerId}`)}
                  >
                    <h3 className="peer-name">{item?.companyName}</h3>
                 

                    <p className="peer-price">₹{item?.price}</p>

                    <p
                      className="peer-change"
                      style={{
                        color: item.percentChange >= 0 ? "#2fd18a" : "#f87171",
                      }}
                    >
                      {item.percent_change >= 0
                        ? `+${item.percentChange}%`
                        : `${item.percentChange}%`}
                    </p>
                  </div>
                ))}
              </div>
            </div> */}
            {/* {!loading && (
              <div
                className="peer-list card"

                
              >
                <h1
            
                >
                  Peer Company Stocks for {companyName}
                </h1>
                <div className="stock-table-container">
                  <table className="stock-table stacked-mobile">
                    <thead>
                      <tr>
                        <th>Company</th>
                        <th>Price</th>
                        <th>% Change</th>
                        <th>PE Ratio</th>

                        <th>Recommendation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mergedPeers?.map((stock) => (
                        <tr
                          key={stock.tickerId}
                          className="stock-row"
                        
                        >
                          <td className="mobile-name">{stock.companyName}</td>
                          <td className="mobile-pair" data-label="Price">
                            ₹{stock.price}
                          </td>

                          <td
                            style={{
                              color:
                                stock.percent_change >= 0
                                  ? "#2fd18a"
                                  : "#f87171",
                              fontWeight: "bold",
                            }}
                            className="mobile-pair"
                            data-label="%Change"
                          >
                            {stock.percentChange}%
                          </td>
                          <td className="mobile-pair" data-label="PE Ratio">
                            {stock.peRatio}
                          </td>

                          <td className="mobile-button">
                            <button
                              className="rec-btn"
                              onClick={() =>
                                navigate(`/stock/${stock.tickerId}`)
                              }
                            >
                              BUY or SELL
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )} */}
            {!loading && (
              <div className="peer-list card">
                <h1>Peer Company Stocks for {companyName}</h1>
                <div className="stock-table-container">
                  <table
                    className="stock-table stacked-mobile"
                    style={{ background: "transparent" }}
                  >
                    <thead style={{ background: "#047cc2", color: "white" }}>
                      <tr>
                        <th>Company</th>
                        <th>Price</th>
                        <th>% Change</th>
                        {/* <th>PE Ratio</th>   */}

                        <th>Recommendation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mergedPeers?.map((stock) => (
                        <tr
                          key={stock.tickerId}
                          className="stock-row"
                          style={{ background: "transparent" }}
                        >
                          <td
                            className="mobile-name"
                            style={{ color: "black" }}
                          >
                            {stock.companyName}
                          </td>
                          <td
                            className="mobile-pair"
                            data-label="Price"
                            style={{ color: "black" }}
                          >
                            ₹{stock.price}
                          </td>

                          <td
                            style={{
                              color:
                                stock.percent_change >= 0
                                  ? "#2fd18a"
                                  : "#f87171",
                              fontWeight: "bold",
                            }}
                            className="mobile-pair"
                            data-label="% Change"
                          >
                            {stock.percentChange}%
                          </td>
                          {/* <td
                          className="mobile-pair"
                          data-label="PE Ratio"
                          style={{ color: "black" }}
                        >
                          {stock.peRatio}
                        </td> */}

                          <td className="mobile-button">
                            <button
                              className="rec-btn"
                              onClick={() =>
                                navigate(`/stock/${stock.tickerId}`)
                              }
                            >
                              BUY or SELL
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SearchStock;
